import { jsx as v } from "react/jsx-runtime";
import { clsx as F } from "clsx";
import { forwardRef as j } from "react";
import l from "./Flex.module.css.js";
const k = j(
  ({
    inline: a = !1,
    fullWidth: f = !1,
    align: i = "flex-start",
    justify: x = "flex-start",
    wrap: m = "wrap",
    direction: n = "row",
    gap: r = 0,
    basis: e,
    grow: o,
    shrink: s,
    alignSelf: t,
    children: c,
    as: p = "div",
    className: y = "",
    style: u = {},
    ...w
  }, G) => {
    const d = Array.isArray(r) ? r[0] : r, A = Array.isArray(r) ? r[1] : r;
    return /* @__PURE__ */ v(
      p,
      {
        ...w,
        ref: G,
        className: F(
          y,
          a ? l.inlineFlex : l.flex,
          f && l.fullWidth
        ),
        style: {
          alignItems: i,
          justifyContent: x,
          flexWrap: m,
          flexDirection: n,
          rowGap: `var(--lok-spacing-${d})`,
          columnGap: `var(--lok-spacing-${A})`,
          ...e && { flexBasis: e },
          ...o && { flexGrow: o },
          ...s && { flexShrink: s },
          ...t && { alignSelf: t },
          ...u
        },
        children: c
      }
    );
  }
);
k.displayName = "Flex";
export {
  k as Flex
};
//# sourceMappingURL=Flex.js.map
